<div class="modal-apollo content-modal">
	<div class="modal-apollo__container">
		<span class="modal-apollo__title">
			<strong>You can choose between two types of content comparison</strong>
		</span>
		<ul>
			<li>
				<strong>For ORDERED text</strong>
					<div class="modal-img">
						<img src='assets/ordered.png' alt='Logo Twona' />
					</div>
					<div class="modal-txt">
						<em>For documents where the order of text in Reference and Target is the same  <span>(leaflets and versions of the same artwork)</span>.</em>
					</div>
					<div class="modal-apollo__btn_graph">
						<core-helpers-forms-button-white  [text]="'ORDERED'" (submit)="actionButton('comparison')"></core-helpers-forms-button-white>
					</div>
			</li>
			<li>
					<strong>For UN-ORDERED text</strong>
					<div class="modal-img">
						<img src='assets/unordered.png' alt='Logo Twona' />
					</div>
					<div class="modal-txt">
						<em>For documents where the Reference and the Target do not follow the same order <span>(brief or regulatory document as reference and designs as target)</span>.</em>
					</div>
					<div class="modal-apollo__btn_graph">
						<core-helpers-forms-button-white  [text]="'UN-ORDERED'" (submit)="actionButton('is-contained')"></core-helpers-forms-button-white>
					</div>
			</li>
		</ul>
		<span class="modal-apollo__description">
			You can change from one type to the other at any time using the selector in the menu.
		</span>

	</div>
</div>
